import styled from 'styled-components';

import DefaultPicture from 'components/picture';

export const Picture = styled(DefaultPicture)`
  max-width: 300px;
  max-height: 300px;
  margin: 0;
`;
